import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProviderPurchasingMechanismsSectionContainer from '../containers/ProviderPurchasingMechanismsSection/ProviderPurchasingMechanismsSection.container'
import ProviderSalesDistributionSectionContainer from '../containers/ProviderSalesDistributionSection/ProviderSalesDistributionSection.container'
import ProviderSectionContainer from '../containers/ProviderSection/ProviderSection.container'
import ProviderTradedAmountsSectionContainer from '../containers/ProviderTradedAmountsSection/ProviderTradedAmountsSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'

/**
 * The Provider's page.
 */
const Provider = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.providers} />
    <SearchBuyerPanelContainer />
    <ProviderSectionContainer>
      <ProviderSalesDistributionSectionContainer />
      <ProviderTradedAmountsSectionContainer />
      <ProviderPurchasingMechanismsSectionContainer />
    </ProviderSectionContainer>
  </BrandLayout>
)

export default Provider
